import $ from "jquery";
import SlickSlider from "../../src/Components/SlickSlider/SlickSlider";

export { $, SlickSlider };